import { useLang } from "@/context/LanguageContext";

/**
 * Flag toggle IT / EN.
 * Compact pill with two circular flags. Active one is highlighted.
 */
export const LangSwitcher = ({ variant = "dark" }) => {
  const { lang, setLang } = useLang();

  const btnBase = "w-8 h-8 rounded-full overflow-hidden flex items-center justify-center transition-all duration-300 ring-2";
  const active = "ring-accent scale-110";
  const inactive = variant === "dark" ? "ring-white/20 opacity-55 hover:opacity-90" : "ring-black/20 opacity-55 hover:opacity-90";

  return (
    <div data-testid="lang-switcher" className="flex items-center gap-2">
      <button
        data-testid="lang-it"
        onClick={() => setLang("it")}
        aria-label="Italiano"
        className={`${btnBase} ${lang === "it" ? active : inactive}`}
        title="Italiano"
      >
        {/* IT flag: green | white | red */}
        <svg viewBox="0 0 3 2" className="w-full h-full">
          <rect width="1" height="2" x="0" fill="#009246" />
          <rect width="1" height="2" x="1" fill="#F1F2F1" />
          <rect width="1" height="2" x="2" fill="#CE2B37" />
        </svg>
      </button>
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        aria-label="English"
        className={`${btnBase} ${lang === "en" ? active : inactive}`}
        title="English"
      >
        {/* UK flag simplified */}
        <svg viewBox="0 0 60 30" className="w-full h-full">
          <clipPath id="uk-c"><path d="M0,0 v30 h60 v-30 z" /></clipPath>
          <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
          <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
          <path clipPath="url(#uk-c)" d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4" />
          <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
          <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
        </svg>
      </button>
    </div>
  );
};
